import { domain } from "@src/utils/request";

export default function setupCardList() {
  const blogListContainers = document.querySelectorAll<HTMLDivElement>(
    ".container-card-list"
  );

  if (!blogListContainers || blogListContainers.length <= 0) return;

  blogListContainers.forEach((item) => {
    item.addEventListener("click", (e) => {
      const authorEle = (e.target as HTMLElement).closest<HTMLDivElement>(
        ".container-card-list-item-author"
      );
      if (!authorEle) return;

      const farmerId = authorEle.dataset.farmerUsername;
      if (!farmerId) return;

      e.stopPropagation();
      e.preventDefault();
      window.location.href = `${domain}/farmers/${farmerId}`;
    });
  });
}
